export default "__VITE_ASSET__BLOmrsQm__"